import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Linkedin } from 'lucide-react';
import NewsletterSignup from './NewsletterSignup';

export default function V2Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-[#E2E8F0]" data-testid="v2-footer">
      <div className="max-w-[1120px] mx-auto px-5 sm:px-6 lg:px-8 py-12">
        {/* Newsletter signup, full-width row at the top of the footer */}
        <div className="mb-10 pb-10 border-b border-[#E2E8F0]" data-testid="footer-newsletter">
          <div className="grid gap-6 md:grid-cols-2 md:items-center">
            <div>
              <h3 className="font-display font-bold text-[#1E2A44] text-xl sm:text-2xl tracking-tight">
                Get one honest email a week.
              </h3>
              <p className="text-[#64748B] mt-1.5 text-sm leading-relaxed">
                No fluff. No daily nagging. Just straight talk on visibility, podcasts and content that actually converts.
              </p>
            </div>
            <NewsletterSignup variant="footer" source="footer" testId="footer-signup" />
          </div>
        </div>

        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="inline-flex items-center gap-2">
              <img
                src="https://customer-assets.emergentagent.com/job_sound-showcase-4/artifacts/9p7oxb75_Audio_%26_Co_Logo_Audio_and_Co_Logo_v2_Black.png"
                alt="Audio & Co.® logo, UK podcast management, book publishing and websites built for SEO"
              title="Audio & Co. | Podcast Management & SEO Websites"
                className="h-9 w-auto"
              />
            </Link>
            <p className="text-sm text-[#64748B] mt-4 leading-relaxed">
              A weekly content engine that helps small business owners be seen and heard, in all the right places.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-[#1E2A44] text-sm mb-3">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pro-plan" className="text-[#475569] hover:text-[#1E2A44]">Pro Plan</Link></li>
              <li><Link to="/podcast-management" className="text-[#475569] hover:text-[#1E2A44]">Podcast Management</Link></li>
              <li><Link to="/authority-hub" className="text-[#475569] hover:text-[#1E2A44]">Business Website</Link></li>
              <li><Link to="/results" className="text-[#475569] hover:text-[#1E2A44]">Results</Link></li>
              <li><Link to="/case-studies" className="text-[#475569] hover:text-[#1E2A44]" data-testid="footer-case-studies">Case studies</Link></li>
              <li><Link to="/podcasts" className="text-[#475569] hover:text-[#1E2A44]">Client shows</Link></li>
              <li><Link to="/websites-apps" className="text-[#475569] hover:text-[#1E2A44]">Website &amp; App Builds</Link></li>
              <li><Link to="/training" className="text-[#475569] hover:text-[#1E2A44]">Training programme</Link></li>
              <li><Link to="/blog" className="text-[#475569] hover:text-[#1E2A44]">Blog &amp; Guides</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-[#1E2A44] text-sm mb-3">Get in touch</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/book/" className="text-[#475569] hover:text-[#1E2A44]">Check if we&apos;re a fit</Link></li>
              <li><Link to="/contact" className="text-[#475569] hover:text-[#1E2A44]">Contact</Link></li>
              <li>
                <a href="mailto:hello@audioandco.com" className="text-[#475569] hover:text-[#1E2A44] inline-flex items-center gap-1.5">
                  <Mail className="w-3.5 h-3.5" /> hello@audioandco.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-[#1E2A44] text-sm mb-3">Follow</h4>
            <div className="flex gap-3">
              <a href="https://instagram.com/audioandco" target="_blank" rel="noreferrer noopener" className="w-9 h-9 rounded-lg bg-[#F6F8FB] hover:bg-[#1E2A44] hover:text-white text-[#1E2A44] flex items-center justify-center transition" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://www.linkedin.com/in/jo-day" target="_blank" rel="noreferrer noopener" className="w-9 h-9 rounded-lg bg-[#F6F8FB] hover:bg-[#1E2A44] hover:text-white text-[#1E2A44] flex items-center justify-center transition" aria-label="LinkedIn">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#E2E8F0] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#64748B]">
          <div>© {year} Audio &amp; Co. All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-[#1E2A44]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#1E2A44]">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
